export interface IColorsBrand {
  stormyBlue: IColorGrades;
  honeyYellow: IColorGrades;
  blueberryPurple: IColorGrades;
  raspberryRed: IColorGrades;
  redRosesRed: IColorGrades;
  skyBlue: IColorGrades;
  royalBlue: IColorGrades;
  carrotOrange: IColorGrades;
  springGrassGreen: IColorGrades;
  grassGreen: IColorGrades;
  ashPink: IColorGrades;
  ashBlue: IColorGrades;
}

export interface IColorGrades {
  120?: string;
  100: string;
  80: string;
  60: string;
  40: string;
  20: string;
}

export interface IColorsStatus {
  success: string;
  warning: string;
  error: string;
  info: string;
}

export interface ISize {
  large: string;
  medium: string;
  small: string;
}

// Notifications colors

const HEVELOCK_BLUE = "#4a90e2";
const APPLE = "#6bb542";
const SELECTIVE_YELLOW = "#f8b400";
const ALIZARIN_CRIMSON = "#E6243C";

// Brand colors

const STORMY_BLUE = {
  "120": "#10171D",
  "100": "#333f48",
  "80": "#5C656D",
  "60": "#858C91",
  "40": "#ADB2B6",
  "20": "#D6D9DA",
};

const HONEY_YELLOW = {
  "100": "#FFC658",
  "80": "#FFD179",
  "60": "#FFDD9B",
  "40": "#FFE8BC",
  "20": "#FFF4DE",
};

const BLUEBERRY_PURPLE = {
  "100": "#5C068C",
  "80": "#9D6ABA",
  "60": "#BE9BD1",
  "40": "#DECDE8",
  "20": "#E5D7ED",
};

const RASPBERRY_RED = {
  "100": "#E03E52",
  "80": "#E66575",
  "60": "#EC8B97",
  "40": "#F3B2BA",
  "20": "#F9D8DC",
};

const RED_ROSES_RED = {
  "100": "#F82229",
  "80": "#F94E54",
  "60": "#FB7A7F",
  "40": "#FCA7A9",
  "20": "#FED3D4",
};

const CARROT_ORANGE = {
  "100": "#FF8C34",
  "80": "#FFA35D",
  "60": "#FFBA85",
  "40": "#FFD1AE",
  "20": "#FFE8D6",
};

const SKY_BLUE = {
  "100": "#59cbe8",
  "80": "#7AD5ED",
  "60": "#9BE0F1",
  "40": "#BDEAF6",
  "20": "#def5fa",
};

const ROYAL_BLUE = {
  "100": "#3247E9",
  "80": "#5B6CED",
  "60": "#8491F2",
  "40": "#ADB5F6",
  "20": "#D6DAFB",
};

const SPRING_GRASS_GREEN = {
  "100": "#89AE43",
  "80": "#A1BE69",
  "60": "#B8CE8E",
  "40": "#D0DFB4",
  "20": "#E7EFD9",
};

const GRASS_GREEN = {
  "100": "#C2E189",
  "80": "#CEE7A1",
  "60": "#DAEDB8",
  "40": "#E7F3D0",
  "20": "#F3F9E7",
};

const ASH_PINK = {
  "100": "#F4C3CC",
  "80": "#F0C9D0",
  "60": "#EDD0D5",
  "40": "#EBD7DB",
  "20": "#E8DEE0",
};

const ASH_BLUE = {
  "100": "#B8DDE1",
  "80": "#C0DDE1",
  "60": "#C9DFE2",
  "40": "#D3E1E3",
  "20": "#DCE3E4",
};

const brand: IColorsBrand = {
  stormyBlue: STORMY_BLUE,
  honeyYellow: HONEY_YELLOW,
  blueberryPurple: BLUEBERRY_PURPLE,
  raspberryRed: RASPBERRY_RED,
  redRosesRed: RED_ROSES_RED,
  skyBlue: SKY_BLUE,
  royalBlue: ROYAL_BLUE,
  carrotOrange: CARROT_ORANGE,
  springGrassGreen: SPRING_GRASS_GREEN,
  grassGreen: GRASS_GREEN,
  ashPink: ASH_PINK,
  ashBlue: ASH_BLUE,
};

const status: IColorsStatus = {
  success: APPLE,
  warning: SELECTIVE_YELLOW,
  error: ALIZARIN_CRIMSON,
  info: HEVELOCK_BLUE,
};

const size: ISize = {
  large: "64px",
  medium: "32px",
  small: "16px",
};

const link = "#0376b0";

export { brand, status, link, size };

// expose below directly

export const BAR_COLOR = {
  succ: "#8884d8",
  total: "#82ca9d",
  goal: "#8884d8",
  intarget: "#ffc658",
  warning: ALIZARIN_CRIMSON,
};

export const WITHBALL_DATA_STATUS = {
  win: "#007f00",
  keep: "#39a2cb",
  lose: "#d32619",
};

export const WITHBALL_DATA_CATEGORY_COLOR = {
  attack: "#1ab394",
  defence: "#f8ac59",
  setball: "#23c6c8",
  foul: "#ed5565",
};

export const MOVE_EVENT_EFFICIENCY_COLOR = {
  effectiveDistance: "#8884d8",
  total: "#82ca9d",
  event: "#ffc658",
  effectiveEvent: "#ed5565",
};
